<template>
  <div class="introduce">
    <p align="center">
      <img class="introduce_img" src="../images/17introduce.jpg" />
    </p>
  </div>
</template>

<script>
export default {
  name: "17introduce",
};
</script>

<style scoped lang="scss">
@import "../scss/baseMain";
</style>
